
import {getOperationsReplenishment} from '../api/getOperationsReplenishment';
import {setGetOperationsReplenishmentAction} from '../action';

const setGetOperationsReplenishment = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getOperationsReplenishment(params);

            if (data.status === 'success') {
                dispatch(setGetOperationsReplenishmentAction(data.data));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetOperationsReplenishment
}